/**
 * A data da notícia, como ela aparece na tela de início.
 *
 * **Curta de propósito, e diferente da do site.** Lá a data fica sozinha acima
 * do título, num cartão largo, e "05 de setembro de 2026" cabe. Aqui ela é a
 * segunda linha de uma fileira de 84px de capa, embaixo de um título que já
 * pode ocupar duas linhas: o ano repetido em três fileiras seguidas vira ruído
 * que ninguém lê, e é justamente o que a seção não pode ser.
 *
 * "Hoje" e "ontem" existem porque a seção se chama **recentes**: a pessoa abre
 * o app todo dia, e o que ela quer saber de relance é se tem coisa nova - não
 * que dia do mês era. O ano volta quando a notícia é de outro ano, e aí ele é
 * informação de verdade.
 *
 * O `hoje` entra por parâmetro para o comportamento poder ser conferido sem
 * congelar o relógio do processo.
 */
const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

/** Dias inteiros entre duas datas, pelo calendário local e não por 24 horas. */
function diasEntre(mais: Date, menos: Date): number {
  const a = Date.UTC(mais.getFullYear(), mais.getMonth(), mais.getDate());
  const b = Date.UTC(menos.getFullYear(), menos.getMonth(), menos.getDate());
  return Math.round((a - b) / 86_400_000);
}

export function dataDaNoticia(iso: string, hoje: Date = new Date()): string {
  const data = new Date(iso);
  // Data inválida não vira "NaN de undefined" na tela: some, e o título fica.
  if (Number.isNaN(data.getTime())) return '';

  const dias = diasEntre(hoje, data);
  if (dias === 0) return 'hoje';
  if (dias === 1) return 'ontem';

  const dia = `${data.getDate()} de ${MESES[data.getMonth()]}`;
  return data.getFullYear() === hoje.getFullYear() ? dia : `${dia} de ${data.getFullYear()}`;
}
